import React, { HTMLAttributes } from 'react';

export const MarkdownListItem: React.FC<HTMLAttributes<HTMLLIElement>> = ({ children }) => {
  return <li>{children}</li>;
};
